export default __webpack_public_path__ + "static/media/arrow.000541fa.svg";